<template>
  <v-row
    justify="center"
  >
    <v-col
      cols="12"
      md="10"
      lg="8"
    >
      <v-dialog
        v-if="userData"
        v-model="dialog"
        max-width="1200px"
        persistent
        scrollable
      >
        <v-card
          class="user-details-card"
        >
          <v-toolbar
            color="primary"
            dark
            flat
            dense
          >
            <v-toolbar-title
              class="text-h5"
            >
              Detalhes do Usuário
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              icon
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text
            class="pt-5"
          >
            <!-- User Header -->
            <v-row no-gutters>
              <v-icon
                large
                color="primary"
                class="mr-3"
              >
                mdi-account-circle
              </v-icon>
              <div>
                <div
                  class="text-h5 font-weight-bold"
                >
                  {{ userData.name }}
                </div>
                <div
                  class="text-subtitle-1 text--secondary"
                >
                  {{ userData.username }}
                </div>
              </div>
              <v-row class="ms-4 d-flex align-center">
                <v-col
                  class="mt-0 pt-0"
                  cols="12"
                  sm="4"
                >
                  <v-switch
                    v-model="userData.enabled"
                    color="success"
                    label="Habilitado"
                    inset
                    hide-details
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="8"
                  class="d-flex justify-end"
                >
                  <v-btn
                    class="rounded-pill mr-2"
                    color="warning"
                    outlined
                    @click="changePassword(userData._id)"
                  >
                    <v-icon
                      left
                    >
                      mdi-lock-reset
                    </v-icon>
                    Alterar senha
                  </v-btn>
                  <v-btn
                    class="rounded-pill"
                    color="error"
                    outlined
                    @click="deleteUser(userData._id)"
                  >
                    <v-icon
                      left
                    >
                      mdi-delete
                    </v-icon>
                    Excluir Usuário
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>

            <v-alert
              v-if="userData.security && userData.security.failedLoginAttempts >= 3"
              type="error"
              icon="mdi-alert-circle-outline"
              prominent
              class="mt-7 rounded-pill d-flex justify-center"
            >
              <span class="text-h5">
                O usuário falhou em 3 ou mais tentativas de login.
              </span>
            </v-alert>

            <v-form
              autocomplete="off"
            >
              <v-divider
                class="border-opacity-75 my-6"
              />

              <!-- Basic Information -->
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="userData.name"
                    label="Nome Completo"
                    prepend-inner-icon="mdi-account"
                    outlined
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="userData.username"
                    label="Email (Nome de Usuário)"
                    prepend-inner-icon="mdi-email"
                    outlined
                    dense
                    disabled
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    :value="moment(userData.createdAt).format('DD/MM/YYYY [às] HH:mm:ss')"
                    label="Criado em"
                    prepend-inner-icon="mdi-calendar-plus"
                    outlined
                    dense
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    :value="moment(userData.updatedAt).format('DD/MM/YYYY [às] HH:mm:ss')"
                    label="Última Atualização"
                    prepend-inner-icon="mdi-calendar-edit"
                    outlined
                    dense
                    disabled
                  />
                </v-col>
              </v-row>
              <!-- USUÁRIOS VINCULADOS ------------------------------------------------- -->
              <v-expansion-panels
                class="ps-0 mt-2"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div class="d-flex align-center">
                      <v-icon
                        left
                        color="primary"
                      >
                        mdi-account-group
                      </v-icon>
                      <span class="text-h5 font-weight-bold primary--text">USUÁRIOS VINCULADOS</span>
                    </div>
                    <v-spacer />
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      class="pe-3 text-end"
                    >
                      <v-btn
                        color="primary"
                        max-width="150"
                        outlined
                        @click="addAssociatedUser"
                      >
                        Adicionar
                      </v-btn>
                    </div>
                    <v-card
                      v-for="(associatedUser, auI) in userData.associatedClinicUsers"
                      :key="`AU${auI}`"
                      class="mt-4 mb-8 px-3"
                    >
                      <v-row>
                        <v-col
                          class="mt-1"
                          cols="6"
                          md="4"
                        >
                          <v-autocomplete
                            v-model="associatedUser.customerCode"
                            :items="customerList"
                            item-text="name"
                            item-value="code"
                            label="Cliente"
                            outlined
                            dense
                            prepend-inner-icon="mdi-account-circle-outline"
                            @change="associatedUser.customerId = customerList.find(c => c.code === associatedUser.customerCode)?._id"
                          />
                        </v-col>

                        <v-col
                          cols="6"
                          md="2"
                        >
                          <v-text-field
                            v-model="associatedUser.customerCode"
                            class="mt-1"
                            label="Código do Cliente"
                            prepend-inner-icon="mdi-clipboard-account-outline"
                            outlined
                            dense
                            disabled
                          />
                        </v-col>
                        <v-col
                          cols="6"
                          md="3"
                        >
                          <v-text-field
                            v-model="associatedUser.customerId"
                            class="mt-1"
                            label="ID do Cliente"
                            prepend-inner-icon="mdi-identifier"
                            outlined
                            dense
                            disabled
                          />
                        </v-col>
                        <v-col
                          class="mt-1"
                          cols="6"
                          md="3"
                        >
                          <v-text-field
                            v-model="associatedUser.clinicUser"
                            label="Código do usuário CLINIC"
                            prepend-inner-icon="mdi-account-key-outline"
                            outlined
                            dense
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="associatedUser.clinicUsername"
                            label="Nome de exibição"
                            prepend-inner-icon="mdi-eye-outline"
                            outlined
                            dense
                          />
                        </v-col>
                        <v-col
                          cols="6"
                          md="1"
                        >
                          <!-- <v-switch
                            v-model="associatedUser.enabled"
                            label="Habilitado"
                          />
                          <v-spacer /> -->
                          <v-btn
                            class="rounded-pill"
                            color="error"
                            text
                            @click="removeAssociatedUser(associatedUser._id)"
                          >
                            Remover
                          </v-btn>
                        </v-col>
                        <!-- <v-col
                          cols="6"
                          md="4"
                        > -->
                        <!-- <v-select
                            v-model="associatedUser.roles"
                            label="Cargos"
                            :items="[]"
                            no-data-text="Nenhum cargo disponível"
                            multiple
                            prepend-inner-icon="mdi-star-box-outline"
                          /> -->
                        <!-- </v-col> -->
                      </v-row>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <!-- SEGURANÇA ------------------------------------------------- -->
              <v-expansion-panels
                class="mt-4"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div class="d-flex align-center">
                      <v-icon
                        left
                        color="primary"
                      >
                        mdi-security
                      </v-icon>
                      <span class="text-h5 font-weight-bold primary--text">SEGURANÇA</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      v-if="userData.security"
                      class="pt-5 px-3"
                    >
                      <v-row>
                        <v-col>
                          <v-switch
                            v-model="userData.security.emailVerified"
                            label="Email verificado"
                          />
                        </v-col>

                        <v-col>
                          <v-text-field
                            v-model="userData.security.failedLoginAttempts"
                            label="Tentativas de login mal sucedidas"
                            hint="Contador zerado após login bem sucedido"
                            persistent-hint
                            outlined
                            dense
                            disabled
                          />
                        </v-col>
                      </v-row>
                      <v-expansion-panels
                        class="mt-4"
                      >
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <v-col
                              cols="12"
                              md="6"
                              class="d-flex align-center"
                            >
                              <v-icon
                                left
                              >
                                mdi-cellphone-link
                              </v-icon>
                              <span class="text-h5 font-weight-bold">Dispositivos ativos</span>
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-chip
                                class="ms-3"
                                color="primary"
                                label
                                outlined
                              >
                                {{ userData.security.activeTokens.length }} {{ userData.security.activeTokens.length > 1 ? 'dispositivos ativos' : 'dispositivo ativo' }}
                              </v-chip>
                            </v-col>
                          </v-expansion-panel-header>

                          <v-expansion-panel-content>
                            <v-card
                              v-for="(activeToken, atI) in userData.security.activeTokens"
                              :key="`AT:${atI}`"
                              class="my-4 px-3"
                            >
                              <v-row>
                                <v-col
                                  cols="6"
                                  md="3"
                                >
                                  <v-text-field
                                    v-model="activeToken.key"
                                    label="Chave"
                                    outlined
                                    dense
                                    disabled
                                  />
                                </v-col>
                                <v-col
                                  cols="6"
                                  md="3"
                                >
                                  <v-text-field
                                    :value="moment(activeToken.issued).format('DD/MM/YYYY [às] HH:mm:ss')"
                                    label="Data de acesso"
                                    outlined
                                    dense
                                    disabled
                                  />
                                </v-col>
                                <v-col
                                  cols="6"
                                  md="3"
                                >
                                  <v-text-field
                                    :value="moment(activeToken.expires).format('DD/MM/YYYY [às] HH:mm:ss')"
                                    label="Expira em"
                                    outlined
                                    dense
                                    disabled
                                  />
                                </v-col>

                                <v-col
                                  cols="6"
                                  md="3"
                                >
                                  <v-btn
                                    color="error"
                                    text
                                    class="rounded-pill"
                                    @click="revokeToken(activeToken._id)"
                                  >
                                    REVOGAR
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel
                          class="mt-4"
                        >
                          <v-expansion-panel-header>
                            <v-col
                              cols="12"
                              md="6"
                              class="d-flex align-center"
                            >
                              <v-icon
                                left
                              >
                                mdi-history
                              </v-icon>
                              <span class="text-h5 font-weight-bold">Histórico de acessos</span>
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-chip
                                class="ms-3"
                                color="primary"
                                label
                                outlined
                              >
                                {{ userData.security.loginHistory.length }} tentativas nos últimos 3 meses
                              </v-chip>
                            </v-col>
                          </v-expansion-panel-header>

                          <v-expansion-panel-content>
                            <v-card
                              v-for="(loginAttempt, latI) in loginHistoryDesc"
                              :key="`LAT:${latI}`"
                              class="my-4 px-3"
                            >
                              <v-row>
                                <v-col
                                  cols="6"
                                  md="3"
                                >
                                  <v-text-field
                                    v-model="loginAttempt.date"
                                    label="Data"
                                    outlined
                                    dense
                                    disabled
                                  />
                                </v-col>
                                <v-col
                                  cols="6"
                                  md="3"
                                >
                                  <v-text-field
                                    v-model="loginAttempt.ip"
                                    label="IP"
                                    outlined
                                    dense
                                    disabled
                                  />
                                </v-col>
                                <v-col
                                  cols="6"
                                  md="3"
                                >
                                  <v-text-field
                                    v-model="loginAttempt.userAgent"
                                    label="Agente"
                                    outlined
                                    dense
                                    disabled
                                  />
                                </v-col>

                                <v-col
                                  class="d-flex justify-center"
                                  cols="6"
                                  md="3"
                                >
                                  <v-btn
                                    :color="loginAttempt.success ? 'success' : 'error'"
                                    class="text-center justify-center rounded-pill"
                                    medium
                                  >
                                    <h4>
                                      {{ loginAttempt.success ? 'Sucesso' : 'Falha' }}
                                    </h4>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-form>
          </v-card-text>

          <v-card-actions
            class="pa-4 pt-0"
          >
            <v-spacer />
            <v-btn
              class="ml-3 rounded-pill"
              color="error"
              text
              @click="dialog = false"
            >
              <v-icon
                left
              >
                mdi-cancel
              </v-icon>
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              class="ml-3 rounded-pill"
              @click="save"
            >
              <v-icon
                left
              >
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>

    <delete-user
      ref="deleteUser"
    />
    <change-password
      ref="changePassword"
    />
  </v-row>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import DeleteUser from './DeleteUser.vue'
  import ChangePassword from './ChangePassword.vue'
  import moment from 'moment'

  export default {
    name: 'UserDetails',
    components: {
      DeleteUser,
      ChangePassword,
    },
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
    props: {
      modelValue: {
        type: String,
        default: undefined,
      },
    },
    emits: ['update:modelValue', 'reload'],
    data: () => ({
      userData: {
        security: {
          activeTokens: [],
          loginHistory: [],
        },
        associatedClinicUsers: [],
      },
    }),
    computed: {
      ...mapGetters('customers', ['customerList']),
      dialog: {
        get () {
          return !!this.modelValue && !!this.userData
        },
        set (value) {
          this.$emit('update:modelValue', null)
        },
      },
      loginHistoryDesc () {
        return [...(this.userData.security.loginHistory || [])].reverse()
      },
    },
    watch: {
      modelValue: {
        immediate: true,
        async handler (newValue) {
          if (newValue) {
            await this.load()
          }
        },
      },
    },
    methods: {
      ...mapActions('users', ['getUser', 'updateUser']),
      ...mapActions('customers', ['listCustomers']),
      moment,
      async load () {
        if (!this.customerList.length) {
          await this.listCustomers()
        }

        try {
          const data = await this.getUser(this.modelValue)
          if (data) {
            this.userData = {
              ...data,
              security: data.security || { activeTokens: [], loginHistory: [], failedLoginAttempts: 0, emailVerified: false },
              associatedClinicUsers: data.associatedClinicUsers || [],
            }
          } else {
            throw new Error('User not found')
          }
        } catch (e) {
          console.error('Failed to load user data:', e)
          if (this.$alert) {
            this.$alert('error', 'Usuário não encontrado')
          } else {
            alert('Error: Usuário não encontrado')
          }
          this.$emit('update:modelValue', null)
        }
      },
      async save () {
        try {
          const payload = JSON.parse(JSON.stringify(this.userData))

          await this.updateUser(payload)
          if (this.$alert) {
            this.$alert('success', 'Usuário salvo com sucesso!')
          } else {
            alert('Usuário salvo com sucesso!')
          }
          this.$emit('update:modelValue', null)
          this.$emit('reload', true)
        } catch (e) {
          console.error('Failed to save user data:', e)
          if (this.$alert) {
            this.$alert('error', 'Erro ao salvar o usuário.')
          } else {
            alert('Erro ao salvar o usuário.')
          }
        }
      },
      addAssociatedUser () {
        if (!this.userData.associatedClinicUsers) {
          this.userData.associatedClinicUsers = []
        }
        this.userData.associatedClinicUsers.unshift({
          enabled: true,
          customerCode: '',
          customerId: '',
          clinicUser: '',
          clinicUsername: '',
          roles: [],
        })
      },
      removeAssociatedUser (id) {
        this.userData.associatedClinicUsers = this.userData.associatedClinicUsers.filter(au => au._id !== id)
      },
      revokeToken (id) {
        this.userData.security.activeTokens = this.userData.security.activeTokens.filter(at => at._id !== id)
      },
      async deleteUser (id) {
        const confirmed = await this.$refs.deleteUser.delete(id)
        if (confirmed) {
          this.$emit('update:modelValue', null)
          this.$emit('reload', true)
        }
      },
      async changePassword (id) {
        await this.$refs.changePassword.change(id)
      },
    },
  }
</script>

<style scoped>
.user-details-card {
  border-radius: 12px;
  overflow: hidden;
}

.rounded-pill {
  border-radius: 50px !important;
  text-transform: none !important;
  font-weight: 600;
}

.v-expansion-panel-header {
  padding: 16px 24px
}

.v-expansion-panel-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
}
</style>
